<p-sidebar [(visible)]="showExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="changedVisibleExportSidebar(false)"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div class="flex flex-column mt-2">
        <label class="export-data-label mb-2">File Type</label>
        <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
    </div>
    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
        <button class="btn-darkblue" pButton label="Download" (click)="export()"></button>
    </div>
</p-sidebar>

<p-dialog
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="exportLoading"
        [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <span class="dialog-header">Downloading data</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data</div>
        <div class="mt-4 spinner"></div>
    </ng-template>
</p-dialog>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <p-toast position="top-right"></p-toast>

    <div class="card">
        <p-table [columns]="cols"
                 [value]="orders"
                [lazy]="true"
                responsiveLayout="auto"
                selectionMode="single"
                dataKey="Id"
                (onLazyLoad)="handleLazyLoad($event)"
                [selection]="selectedOrder"
                (selectionChange)="onSelectionChange($event.data)"
                [paginator]="true"
                [(first)]="first"
                [rows]="rowsPerPage"
                [showFirstLastIcon]="false"
                [totalRecords]="totalRecords"
                [resizableColumns]="true"
                [columnResizeMode]="'expand'"
                [styleClass]="'p-datatable-gridlines'"
                [scrollable]="true"
                [autoLayout]="true"
                [loading]="loading"
                [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-title">
                        Orders Report
                    </div>
                    <div class="flex flex-row finance-head-right">
                        <p-calendar [(ngModel)]="orderHeaderSearch.startDate" class="mr-4 mt-2" dateFormat="'From': dd-M-yy" placeholder="From:"
                                    [maxDate]="orderHeaderSearch.endDate" (ngModelChange)="onChangeHeaderFilterDropDown('StartDate', null)"></p-calendar>

                        <p-calendar [(ngModel)]="orderHeaderSearch.endDate" class="mr-4 mt-2" dateFormat="'To': dd-M-yy" placeholder="To:"
                                    [minDate]="orderHeaderSearch.startDate" (ngModelChange)="onChangeHeaderFilterDropDown('EndDate', null)"></p-calendar>

                        <div class="ml-4">
                            <button pButton pRipple
                                    class="p-element btn-darkblue p-button p-component"
                                    (click)="showSidebar()">Export Data</button>
                        </div>
                        <div class="ml-5 mt-2 mr-2">
                            <column-selector #columnSelector
                                             [defaultColumns]="defaultCols"
                                             (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                             [tableName]="tableName"
                                             [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText
                                       placeholder="{{filter.placeholder}}"
                                       [(ngModel)]="orderHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.model, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly"
                                               placeholder="{{filter.placeholder}}"
                                               [(ngModel)]="orderHeaderSearch[filter.model]"
                                               (onInput)="handleFilterChange(filter.model, $event.value)">
                                </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputDecimalNumber">
                                <p-inputNumber [minFractionDigits]="2"
                                               placeholder="{{filter.placeholder}}"
                                               [(ngModel)]="orderHeaderSearch[filter.model]"
                                               (onInput)="handleFilterChange(filter.model, $event.value)">
                                </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <p-dropdown [options]="filter.options"
                                            placeholder="{{filter.placeholder}}"
                                            optionLabel="name"
                                            optionValue="value"
                                            [(ngModel)]="orderHeaderSearch[filter.model]"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.model, $event)"
                                            [showClear]="true">
                                </p-dropdown>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="orderHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.model, $event)"
                                            [showClear]="true">
                                </p-calendar>
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-order let-columns="columns">
                <tr [pSelectableRow]="order">
                    <td *ngFor="let col of cols">
                        <span *ngIf="col.field === 'Id'">
                            {{ order[col.field] }}
                            </span>
                        <span *ngIf="col.field === 'CustomerName' && order.XpressUserId"
                              class="underline-black-col" (click)="handleShowCustomerInfo(order)">
                                 {{ order[col.field] }}
                             </span>
                        <span *ngIf="col.field === 'DriverName' && order.XpressRiderId">
                                 {{ order[col.field] }}
                             </span>
                        <span *ngIf="col.field !== 'Id' && col.field !== 'CustomerName' && col.field !== 'DriverName'">
                                <ng-container *ngIf="col.field === 'InitialTotalFareAmount' || col.field === 'PromoAmount'; else defaultField">
                                    {{ order[col.field] | currency:'PHP':'symbol':'1.2-2' }}
                                </ng-container>
                                <ng-template #defaultField>
                                    {{ order[col.field] }}
                                </ng-template>
                            </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="orders && orders.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + orders.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="cols.length">
                        No orders found.
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<customer-info *ngIf="visibleCustomerDetail"
               [isVisibleCustomerInfo]="visibleCustomerDetail"
               [_customerId]="transactionCustomerId"
               (changedVisibleCustomerInfoEmit)="changedVisibleCustomerDetailEmit($event)">
</customer-info>